// extracted by mini-css-extract-plugin
export var chevron = "_15-d";
export var disabled = "_15-b";
export var error = "_15-c";
export var hideBorder = "_15-1";
export var icon = "_15-e";
export var input = "_15-0";
export var large = "_15-f";
export var open = "_15-9";
export var placeholder = "_15-a";
export var regular = "_15-5";
export var singleRowInput = "_15-2";
export var singleSelectInput = "_15-3 _15-0";
export var small = "_15-4";
export var spinnerContainer = "_15-i";
export var tag = "_15-7";
export var tagsContainer = "_15-8";
export var tagsInput = "_15-6 _15-0";
export var xSmall = "_15-g";
export var xxSmall = "_15-h";